module.exports = __webpack_public_path__ + "static/media/ramos.9ca249d5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/clubs/ramos.jpg
// module id = 90
// module chunks = 0